import Rails from '@rails/ujs'
import './alpine'
import '../controllers/cargo'
import '../css/cargo.scss'

require.context('../assets/', true, /\.(svg|jpg|png)$/)
Rails.start()
